import {
  DEFAULT_STORE_TEXT,
  eFoodConfigDefaultState,
  trackingDefaultState,
} from "_redux/reducers/initStates";
import type { RootReducerState, SiteInfo } from "../reducers";
import { createSelector } from "@reduxjs/toolkit";
import { localStorageUtil } from "_foundationExt/utils/storageUtil";
import { LOCALE } from "_foundation/constants/common";
import {
  CommerceEnvironment,
  FALLBACK_LANGUAGE_ID,
  MARKETPLACE_DISPLAY_NAME_FALLBACK_SERVICEBUND,
} from "constants/common";

export const siteSelector = (state: RootReducerState) => state.site.currentSite;

export const efoodSelector = (state: RootReducerState) =>
  state.site.currentSite?.storeCfg.efood ?? eFoodConfigDefaultState;

export const selectStoreText = (state: RootReducerState) =>
  state.site.currentSite?.storeCfg.efood.storeText ?? DEFAULT_STORE_TEXT;

export const storeListSelector = (state: RootReducerState) =>
  state.site.currentSite?.storeCfg.efood.storeList || [];

export const supportedLanguagesSelector = (state: RootReducerState) =>
  state.site.currentSite?.supportedLanguages;

export const trackingSelector = (state: RootReducerState) =>
  state.site.currentSite?.storeCfg.efood.tracking || trackingDefaultState;

export const scrollToTopSelector = (state: RootReducerState) =>
  state.site.scrollToTop;

export const showDialogSelector = (state: RootReducerState) =>
  state.site.showDialog;

export const onlineStatusSelector = (state: RootReducerState) =>
  state.site.onlineStatus;

export const selectOnlineStatus = (state: RootReducerState) =>
  state.site.onlineStatus.status;

export const selectForceStandaloneMode = (state: RootReducerState) =>
  state.site.forceStandaloneMode;

export const selectSyncManuallyTriggered = (state: RootReducerState) =>
  state.site.syncManuallyTriggered;

export const selectSyncRunning = (state: RootReducerState) =>
  state.site.syncRunning;

export const selectCurrentLangId = createSelector(
  [siteSelector],
  (currentSite): string => {
    // Get the current language
    const storedLocale = localStorageUtil.get(LOCALE);
    const langId =
      CommerceEnvironment.reverseLanguageMapShort[storedLocale] ??
      currentSite?.defaultLanguageID ??
      FALLBACK_LANGUAGE_ID;

    return langId;
  }
);

export const selectDisplayNameOfStore = createSelector(
  [siteSelector, selectCurrentLangId],
  (currentSite, langId) => {
    return (
      currentSite?.storeCfg.description?.find((d) => d.languageId === langId)
        ?.displayName ??
      currentSite?.storeName ??
      MARKETPLACE_DISPLAY_NAME_FALLBACK_SERVICEBUND
    );
  }
);
